import React from 'react';
import Box from '@mui/material/Box';
import {
  NotificationSettings,
  OrganizationDetails,
  ResponsibleTeam,
  SecuritySettings,
  SupportAndContact,
} from './Components';

export const AdvancedSettings: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
        gap: 3,
        py: 2,
      }}
    >
      <OrganizationDetails
        id='org-123'
        name='Acme Corp'
        industry='Technology'
        location='San Francisco'
        timeZone='PST'
        onSave={(data) => {
          console.log('Saving organization details:', data);
        }}
      />
      <SupportAndContact />
      <ResponsibleTeam />
      <NotificationSettings />
      <SecuritySettings />
    </Box>
  );
};
